// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll[data-v-01548430]::-webkit-scrollbar{height:4px;width:4px}.scroll[data-v-01548430]::-webkit-scrollbar-track{box-shadow:inset 0 0 6px #eee}.scroll[data-v-01548430]::-webkit-scrollbar-thumb{background-color:#0f95e8}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
